<template lang="pug">
.PersonalAccountNavigationItemComponent
  template(v-if="item.route")
    router-link.link(
      :to="item.route",
      active-class="_active"
    ) {{ item.label }}
  template(v-else) {{ item.label }}
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: null
    }
  }
}
</script>

<style lang="sass" scoped>
.PersonalAccountNavigationItemComponent
  margin: 2*$u 0
  @include font('t16-medium')
  .link
    border: 0.75*$u solid $cBlue
    border-radius: 4*$u
    padding: 2.5*$u 3.5*$u
    background-color: transparent
    white-space: nowrap
    @media (max-width: $padWidth)
      padding: 2*$u

    &:hover
      background-color: $cWhite
      box-shadow: 0 2*$u 4.5*$u rgba(37, 64, 142, 0.2)
    &._active
      background-color: $cDarkBlue
      color: $cWhite
      border-color: $cDarkBlue
</style>
